export class AssetElementsBuilder {
    taxonomyElement(element) {
        return element;
    }
}
export const assetElementsBuilder = new AssetElementsBuilder();
//# sourceMappingURL=asset-elements.builder.js.map